<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>项目名称:</span>
          <el-input
            class="search-input"
            placeholder="项目名称"
            v-model="searchQuery.projectName"
            clearable
          />
        </div>
        <div>
          <span>任务月度:</span>
          <el-date-picker
            range-separator="-"
            value-format="yyyy-MM"
            type="month"
            v-model="searchQuery.taskDt"
          />
        </div>
        <div>
          <span>支付截止时间:</span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="searchQuery.orderEndPayDt"
          />
        </div>
        <div>
          <span>订单编号:</span>
          <el-input
            class="search-input"
            placeholder="订单编号"
            v-model="searchQuery.orderNo"
            clearable
          />
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">查询</el-button>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="序号"
          type="index"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderNo"
          type="expand"
        >
          <template slot-scope="{ row }">
            <div class="expandBox">
              <p>项目订单</p>
              <div class="orderNo">
                <p>订单编号：</p>
                <p>{{ row.orderNo }}</p>
              </div>
              <div class="orderNo">
                <p>项目金额：</p>
                <div style="display:flex;align-items:center;">
                  <span style="margin-right:10px;">
                    {{ (row.projectPrice - row.discountPrice) | moneyFixed }}
                  </span>
                  <el-button
                    primary
                    type="text"
                    style="padding:0;"
                    @click="showComponent('payDetail', row)"
                  >
                    详情
                  </el-button>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    v-if="
                      searchQuery.projectStructureType == 1 && row.discountPrice
                    "
                  >
                    <div>
                      应付：{{
                        (row.initOrderPrice - row.platformServicesPrice)
                          | moneyFixed
                      }}
                    </div>
                    <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                    <div>
                      实付：{{
                        (row.orderPrice - row.platformServicesPrice)
                          | moneyFixed
                      }}
                    </div>
                    <img
                      src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                      slot="reference"
                      class="info"
                    />
                  </el-popover>
                </div>
              </div>
              <div>
                <p>支付状态：</p>
                <p>已失效</p>
              </div>
              <div class="orderNo">
                <p>支付时间：</p>
                <p>-</p>
              </div>
              <el-button
                primary
                type="text"
                @click="rePay(row)"
                style="flex:1"
                :disabled="!!row.newOrderId || row.servicesPricePayStatus == 1"
              >
                {{ payStatusHandlerName(row.newOrderId) }}
              </el-button>
            </div>
            <div class="expandBox" v-if="row.serviceOrderNo">
              <p>平台服务费订单</p>
              <div class="orderNo">
                <p>订单编号：</p>
                <p>{{ row.serviceOrderNo }}</p>
              </div>
              <div class="orderNo">
                <p>平台服务费：</p>
                <div style="display:flex;align-items:center;">
                  <span style="margin-right:10px;">
                    {{ row.platformServicesPrice | moneyFixed }}
                  </span>
                  <el-button
                    primary
                    type="text"
                    style="padding:0;"
                    @click="showComponent('serviceDetail', row)"
                  >
                    详情
                  </el-button>
                </div>
              </div>
              <div>
                <p>支付状态：</p>
                <p>{{ row.servicesPricePayStatus | serviceStatus }}</p>
              </div>
              <div class="orderNo">
                <p>支付时间：</p>
                <p>{{ row.servicePayDt | transAllTime }}</p>
              </div>
              <el-button
                primary
                type="text"
                :disabled="row.serviceOrderStatus != 1"
                @click="showComponent('servicePay', row)"
                style="flex:1"
              >
                {{ searvicePayHandler(row.servicesPricePayStatus) }}
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="订单生成时间"
        >
          <template slot-scope="{ row }">
            {{ row.createDt | transDate }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="支付截止时间"
        >
          <template slot-scope="{ row }">
            {{ row.orderEndPayDt | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="本次需打款总金额"
          width="120"
        >
          <template slot-scope="{ row }">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ row.orderPrice | moneyFixed }}</span>
              <el-popover
                placement="top-start"
                trigger="hover"
                v-if="row.discountPrice"
              >
                <div>应付：{{ row.initOrderPrice | moneyFixed }}</div>
                <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                <div>实付：{{ row.orderPrice | moneyFixed }}</div>
                <img
                  src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                  slot="reference"
                  class="info"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="payStatus"
          label="支付状态"
        >
          <template>
            <span>已失效</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="rePay(row)"
              :disabled="!!row.newOrderId || row.servicesPricePayStatus == 1"
            >
              {{ payStatusHandlerName(row.newOrderId) }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <component
      :is="componentName"
      :show-dialog="showDetail"
      :type="type"
    ></component>
  </div>
</template>

<script>
import payDetail from './payDetail.vue';
import qualifyDetail from './qualifyDetail.vue';
import serviceDetail from './serviceDetail.vue';
import confirmPay from './confirmPay.vue';
import { projectOrderInvalidList, projectV2 } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import { projectOrderPayStatus } from '@/config/staticData';
import { mapActions } from 'vuex';
import sanji from '@/Mixin/sanji';
import dingdanFillProjectName from '@/Mixin/dingdanFillProjectName';
export default {
  mixins: [pageInation, makeSure, sanji, dingdanFillProjectName],
  props: {
    chooseType: {
      type: Number
    }
  },
  data() {
    return {
      projectOrderPayStatus,
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: projectOrderInvalidList, // 获取列表的AJAX
      searchQuery: {
        hasPay: 0,
        projectName: '',
        orderNo: '',
        payStatus: ''
      },
      showDetail: false,
      componentName: '',
      type: '',
      // 下发当前选中的item
      item: {
        data: null
      }
    };
  },
  components: {
    dicSelect,
    payDetail,
    qualifyDetail,
    serviceDetail,
    confirmPay
  },
  provide() {
    return {
      itemData: this.item
    };
  },
  methods: {
    ...mapActions(['syncProjectInfo']),
    searvicePayHandler(payStatus) {
      if ([0, 3].includes(payStatus)) {
        return '支付';
      } else {
        return '详情';
      }
    },
    async rePay(row) {
      row.id = row.projectId;
      row.projectStructureType = 1; //只有四级才有失效订单 所以type写死成1
      let serviceSubitem = '';
      try {
        if (row.projectType == 20) {
          const {
            data: { data }
          } = await projectV2.getServiceSubitemByProjectId(row);
          serviceSubitem = (data || {}).serviceSubitem;
        }
      } catch (err) {
        console.error(err);
      }
      this.syncProjectInfo({ ...row, serviceSubitem }).then(() => {
        this.$router.push({
          name: 'assign',
          query: { id: row.projectId }
        });
      });
    },
    payStatusHandlerName(newOrderId) {
      if (newOrderId) {
        return '已重新生成';
      } else {
        return '重新生成订单';
      }
    },
    showComponent(componentName, item = null) {
      if (componentName == 'servicePay') {
        //服务费处支付
        this.type = 2;
        this.componentName = 'confirmPay';
      } else {
        this.componentName = componentName;
      }
      this.item.data = item;
      localStorage.setItem('activeTask', JSON.stringify(item));
      // item ? (this.type = item.type) : "";
      this.showDetail = true;
    }
  },
  created() {},
  filters: {
    payStatusFil(v) {
      let s = {
        1: '待支付',
        2: '支付中',
        3: '支付失败',
        4: '部分支付成功',
        5: '支付中',
        6: '支付失败'
      };
      return s[v];
    },
    serviceStatus(v) {
      let s = {
        0: '待支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败'
      };
      return s[v];
    }
  },
  watch: {
    chooseType: {
      immediate: true,
      handler(v) {
        if (/threeFlex/.test(this.$route.path)) {
          if (v === 1) {
            this.searchQuery.projectStructureType = 3;
          } else if (v === 2) {
            this.searchQuery.projectStructureType = 1;
          }
          this.initWatchRouteChange();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 14px;
  height: 14px;
  margin-top: -4px;
}
</style>
